interface AnalyticsEvent {
  id: string;
  session_id: string;
  event_type: string;
  event_data: Record<string, unknown>;
  referrer: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  device_type: string | null;
  country: string | null;
  created_at: string;
}

const escapeCSV = (value: unknown): string => {
  if (value === null || value === undefined) return '';
  const str = typeof value === 'object' ? JSON.stringify(value) : String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const exportEventsToCSV = (events: AnalyticsEvent[], filename: string) => {
  const headers = ['id', 'session_id', 'event_type', 'event_data', 'referrer', 'utm_source', 'utm_medium', 'utm_campaign', 'device_type', 'country', 'created_at'];

  const rows = events.map(e =>
    [e.id, e.session_id, e.event_type, e.event_data, e.referrer, e.utm_source, e.utm_medium, e.utm_campaign, e.device_type, e.country, e.created_at]
      .map(escapeCSV)
      .join(',')
  );

  const csv = [headers.join(','), ...rows].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
